import { Injectable } from '@angular/core';
import { AppConstants } from '@shared/app-constants';

@Injectable({
  providedIn: 'root'
})
export class WindowSizeService {
  private devices = {
    xs: [0, AppConstants.BREAKPOINTS.sm],
    sm: [AppConstants.BREAKPOINTS.sm, AppConstants.BREAKPOINTS.md],
    md: [AppConstants.BREAKPOINTS.md, AppConstants.BREAKPOINTS.lg],
    lg: [AppConstants.BREAKPOINTS.lg, 10000]
  };

  viewportWidth() {
    // in case we are in angular universal
    if (typeof window !== 'undefined') {
      let e: Window | HTMLElement = window;
      let a = 'inner';

      if (!window.innerWidth) {
        a = 'client';
        e = document.documentElement || document.body;
      }

      return e[a + 'Width'];
    } else {
      return '100%';
    }
  }

  viewportHeight() {
    // in case we are in angular universal
    if (typeof window !== 'undefined') {
      let e: Window | HTMLElement = window;
      let a = 'inner';

      if (!window.innerHeight) {
        a = 'client';
        e = document.documentElement || document.body;
      }

      return e[a + 'Height'];
    } else {
      return '100%';
    }
  }

  deviceSize() {
    const devices = {};
    const clientWidth = this.viewportWidth();

    for (const device in this.devices) {
      if (this.devices[device][0] <= clientWidth && this.devices[device][1] > clientWidth) {
        devices[device] = true;
      } else {
        devices[device] = false;
      }
    }

    return devices;
  }

  currentSize() {
    let size;
    const devices = this.deviceSize();

    for (const device in devices) {
      if (devices[device] === true) {
        size = device;
      }
    }

    return size;
  }
}
